import { useTranslation } from "react-i18next";
import { Trees } from "lucide-react";

export const Footer = () => {
  const { t } = useTranslation();

  return (
    <footer 
      className="py-12 bg-stone-900 text-white"
      data-testid="footer"
    >
      <div className="max-w-5xl mx-auto px-6">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-8">
          {/* Brand */}
          <div>
            <a href="/" className="flex items-center gap-2.5 mb-4">
              <div className="w-9 h-9 rounded-lg bg-[#1B4D3E] flex items-center justify-center">
                <Trees className="w-5 h-5 text-white" />
              </div>
              <span 
                className="text-lg font-semibold" 
                style={{ fontFamily: 'Outfit, sans-serif' }}
              >
                ForestHub
              </span>
            </a>
            <p className="text-sm text-stone-400 mb-4">
              {t('footer.claim')}
            </p>
            <p className="text-xs text-stone-500">
              {t('footer.company')}
            </p>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-semibold mb-4">{t('footer.contact')}</h4>
            <div className="space-y-2 text-sm text-stone-400">
              <p>Hodema edertools AB</p>
              <p>Kyrkvägen 66</p>
              <p>88372 Backe, Sweden</p>
              <a 
                href="mailto:info@hodema.se" 
                className="hover:text-white transition-colors block mt-3"
              >
                info@hodema.se
              </a>
            </div>
          </div>

          {/* Legal */}
          <div>
            <h4 className="font-semibold mb-4">{t('footer.legal')}</h4>
            <div className="space-y-2 text-sm">
              <a 
                href="/impressum" 
                className="text-stone-400 hover:text-white transition-colors block"
              >
                {t('footer.impressum')}
              </a>
              <a 
                href="/datenschutz" 
                className="text-stone-400 hover:text-white transition-colors block"
              >
                {t('footer.privacy')}
              </a>
              <a 
                href="/nutzungsbedingungen" 
                className="text-stone-400 hover:text-white transition-colors block"
              >
                {t('footer.terms')}
              </a>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-stone-800 pt-8">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4 text-sm text-stone-500">
            <p>© {new Date().getFullYear()} ForestHub. {t('footer.rights')}</p>
            <a 
              href="https://www.hodema.se" 
              target="_blank" 
              rel="noopener noreferrer"
              className="text-stone-400 hover:text-white transition-colors"
            >
              www.hodema.se
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};
